// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QN4N","top":"styles_top__8BNTK","left":"styles_left__2TXTu","description":"styles_description__1b3AT"};